module.exports = __webpack_public_path__ + "img/84.9e9c0273.jpg";